import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=129d4606&scoped=true"
import script from "./DeleteGroup.vue?vue&type=script&lang=js"
export * from "./DeleteGroup.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroup.vue?vue&type=style&index=0&id=129d4606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d4606",
  null
  
)

export default component.exports